import type { User } from '@/store/auth.store';

/** Login initially returns a partial profile; explicit non-active status always denies.
 * The server independently reloads ACTIVE status and raw role on every request. */
export function isPlatformBetaOperator(
  user: Pick<User, 'platformRole' | 'status'> | null | undefined
): boolean {
  return (
    user?.platformRole === 'Super Admin' && (user.status === undefined || user.status === 'ACTIVE')
  );
}
